module.exports = __webpack_public_path__ + "static/media/stethoscope.616c370b.svg";